import { sortBy } from "lodash"
import { CustomSortIterateeOutput, TableColumnSortOrder } from "./types"

export const getNewSortValue = (
  currentSortValue: TableColumnSortOrder | undefined
): TableColumnSortOrder | undefined => {
  if (!currentSortValue) return `ASC`
  if (currentSortValue === `ASC`) return `DESC`
  return undefined
}

export const getNewDataPage = <T extends {}>(data: ReadonlyArray<T>, pageindex: number, pageSize: number) => {
  const startIndex = pageSize * pageindex
  return data.slice(startIndex, startIndex + pageSize)
}

export const getSortedData = <T extends {}>(
  initalData: ReadonlyArray<T>,
  property: keyof T,
  sort: TableColumnSortOrder | undefined,
  customIteratee?: (item: T) => CustomSortIterateeOutput
) => {
  if (!sort) return initalData
  const sortedAsc = sortBy(initalData, customIteratee || property)
  if (sort === `ASC`) return sortedAsc
  return sortedAsc.reverse()
}
